import { ITheme, Theme } from '../../../common/types';
import { Colors } from '../../colors';
import { BaseTheme } from '../base';

export const DarkTheme: ITheme = {
  ...BaseTheme,
  name: Theme.DARK,
  colors: {
    primary: Colors.G300,
    secondary: Colors.BLACK,
    appBgColor: Colors.DB100,
  },
};
